import { APP_LANGUAGE_CODES } from '@@/languageConfig';



export type AppLanguageCode = typeof APP_LANGUAGE_CODES[keyof typeof APP_LANGUAGE_CODES];


export const AppLanguageCodes = APP_LANGUAGE_CODES;


export function isAppLanguageCode(value: unknown): value is AppLanguageCode {
	return typeof value === 'string' && Object.values(APP_LANGUAGE_CODES).includes(value as AppLanguageCode);
}